import * as React from 'react';
import { UitkImage } from 'uitk-react-images';
import { Lazy } from 'src/common/components/common/lazy/lazy';
import { PropertyAlternateDestinations } from 'src/common/__generated__/api';

export interface AlternateDestinationImageProps {
  image?: PropertyAlternateDestinations.Image;
}

export class AlternateDestinationImage extends React.Component<AlternateDestinationImageProps> {
  public render() {
    const { image } = this.props;
    const description = image ? image.description : '';
    const placeholder = <UitkImage placeholderImage={true} alt="" />;

    return (
      <Lazy>
        <Lazy.Placeholder>{placeholder}</Lazy.Placeholder>
        <Lazy.Loaded>{image && image.url ? <UitkImage alt={description} src={image.url} /> : placeholder}</Lazy.Loaded>
      </Lazy>
    );
  }
}
